import { render, staticRenderFns } from "./MobileAppBanner.vue?vue&type=template&id=71bfc3c0&scoped=true"
import script from "./MobileAppBanner.vue?vue&type=script&lang=js"
export * from "./MobileAppBanner.vue?vue&type=script&lang=js"
import style0 from "./MobileAppBanner.vue?vue&type=style&index=0&id=71bfc3c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bfc3c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
